export default class EditInstructingPartyViewmodel {
    public id: number = 0;
    public companyName: string = '';
    public contactName: string = '';
    public jobTitle: string = '';
    public email: string = '';
    public office: string = '';
}